<template>
  <sui-page>
    <sui-page-header title="상신 의견" />
    <sui-page-contents>
      <div class="comm_title_wrap">
        <h4><!-- 승인/합의/반려 의견 -->{{ titleText }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <!-- 제목 -->
          <div class="col-xs-2">
            <sui-input-label :label="$t('MSG_TIT_TTL')" />
          </div>
          <div class="col-xs-10">
            {{ pageInitialData.approvalTitle }}
          </div>
        </div>
        <div
          v-if="!usePassword"
          class="row"
        >
          <!-- 작성자 -->
          <div class="col-xs-2">
            <sui-input-label :label="$t('MSG_TIT_DOC_CRTR')" />
          </div>
          <div class="col-xs-10">
            {{ pageInitialData.drafterSummary }}
          </div>
        </div>
        <div
          v-if="usePassword"
          class="row"
        >
          <!-- 비번 -->
          <div class="col-xs-2">
            <sui-input-label :label="$t('MSG_TXT_PW')" />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              ref="textFieldPassword"
              v-model="password"
              :password="true"
              maxlength="100"
            />
          </div>
        </div>
        <div class="row">
          <!-- 의견 -->
          <div class="col-xs-2">
            <sui-input-label :label="$t('MSG_TIT_OPN')" />
          </div>
          <div class="col-xs-10">
            <sui-textarea
              v-model="approvalOpinionContent"
              extensible
              :rows="5"
              :maxlength="1024"
            />
          </div>
        </div>
      </div>
    </sui-page-contents>
    <!-- Page Footer -->
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <!-- 취소 -->
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onClickCancel"
        >
          {{ $t("MSG_BTN_CNCL") }}
        </sui-button>
        <!-- 승인, 합의, 반려 -->
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onClickNextAction"
        >
          {{ btnText }}
        </sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';
const BTN_TEXT = {
  1: utils.getMessageById('MSG_TXT_APPR'), // 승인 this.$t('MSG_TXT_APPR')
  2: utils.getMessageById('MSG_TXT_AGRM'), // 합의 this.$t('MSG_TXT_AGRM')
  3: utils.getMessageById('MSG_BTN_RJT'), // 반려 this.$t('MSG_BTN_RJT')
};

export default {
  name: 'PGE_CML_00012', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default: null,
    },
    pageInitialData: {
      type: Object,
      required: true,
      default() {
        return {
          approvalTitle: '',
          drafterSummary: '',
          opinionTypeNo: 0, // 1: 승인, 2: 합의, 3: 반려
        };
      },
    },
  },
  data() {
    return {
      approvalOpinionContent: '',
      btnText: BTN_TEXT[this.pageInitialData.opinionTypeNo], // '승인', '합의', '반려'
      password: '',
      titleText: `${BTN_TEXT[this.pageInitialData.opinionTypeNo]} ${this.$t('MSG_TIT_OPN')}`,
      usePassword: utils.getConfigurationValue('CFG_CML_USE_APRV_PW') === 'Y',
    };
  },
  computed: {},
  watch: {},
  datasets: [],
  mounted() {
    if (utils.trim(this.pageInitialData.approvalTitle) === '') {
      // TODO:
      utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), '제목이 존재하지 않습니다.', null, () => {
        this.closePagePopup({
          goNext: false,
        });
      });
    } else if ([1, 2, 3].indexOf(this.pageInitialData.opinionTypeNo) === -1) {
      // TODO:
      utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), '의견 종류가 존재하지 않습니다.', () => {
        this.closePagePopup({
          goNext: false,
        });
      });
    }
  },
  methods: {
    /**
     * '취소' 버튼 click event handler
     */
    onClickCancel() {
      this.closePagePopup({
        goNext: false,
      });
    },
    /**
     * '승인/합의' 버튼 click event handler
     */
    async onClickNextAction() {
      if (this.usePassword) {
        const checkResult = await this.checkLoginUserPassword();
        if (!checkResult) return false;
      }

      this.closePagePopup({
        goNext: true,
        approvalOpinionContent: this.approvalOpinionContent,
        password: this.password,
      });
      return true;
    },
    checkLoginUserPassword() {
      return new Promise(resolve => {
        http.request(this.contextPageId, 'DTS_CML_00017', {
          query: {
            userPasswordValue: this.password,
          },
        }).then(() => {
          resolve(true);
        }).catch(() => {
          resolve(false);
        });
      });
    },
  },
};
</script>
<style scoped>
</style>
